export class OrganizationEvent {

  public Id: string;
  public UniqueId: string;
  public Title: string;
  public EventDate: Date;
  public EventDay: string;
  public Description: string;
  public Recurrence: string;
  public AllDayEvent: string;
  public EndDate: Date;
  public Location: string;
  public RecurrenceData: string;
  public Duration: any;
  public ItemUrl: string;
  public OrganizationCalendarName: string;
  public EventInstance: string;
  public BannerUrl: string;
  public ListGuid: string;
  public ShowNewOrModifiedBadge: boolean;
  public Channels: Array<any>;
  public LanguageTermId?: string;

  constructor(opt?: Partial<OrganizationEvent>) {
    Object.assign(this, opt);
  }

}
